import { render, staticRenderFns } from "./VideoTutorial.vue?vue&type=template&id=31766cf0&scoped=true"
import script from "./VideoTutorial.vue?vue&type=script&lang=js"
export * from "./VideoTutorial.vue?vue&type=script&lang=js"
import style0 from "./VideoTutorial.vue?vue&type=style&index=0&id=31766cf0&prod&lang=scss"
import style1 from "./VideoTutorial.vue?vue&type=style&index=1&id=31766cf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31766cf0",
  null
  
)

export default component.exports